import { mapActions, mapGetters } from 'vuex'

export const routable = {
  computed: {
    ...mapGetters([
      'checkQuickLaunch'
    ])
  },
  methods: {
    ...mapActions([
      'addQuickLaunch',
      'removeQuickLaunch'
    ]),
    launchApp(name, route) {
      if (route) {
        this.$router.push({ name: name })
      } else {
        this.$router.push({ name: 'menu', params: { id: name } })
      }
    },
    toggleQuickLaunch(name) {
      if (this.checkQuickLaunch(name)) {
        this.removeQuickLaunch(name)
      } else {
        this.addQuickLaunch(name)
      }
    }
  }
}

export default routable
